<template>
  <ExternalLink
    :url="`${LINK_TYPE_HREF.PHONE}${phoneNumber}`"
    class="flex items-center gap-2 whitespace-nowrap"
  >
    <span
      v-if="showIcon"
      class="iconify fa-pro-light--phone text-base"
    />
    {{ phoneNumber }}
  </ExternalLink>
</template>

<script lang="ts">

import { LINK_TYPE_HREF } from '~~/constants/html';

export default defineComponent({
  name: 'PhoneNumber',

  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
    phoneNumber: {
      type: String,
      default: '',
    },
  },
  setup() {

    return {
      LINK_TYPE_HREF,
    };
  
  },
});

</script>
